import React from 'react';
import { Separator } from '../ui/separator';
import { Command, Heart } from 'lucide-react';
import { Icon } from '../ui/icon';
import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="shrink-0 border-t border-border bg-background/80 backdrop-blur-sm">
      <div className="px-4 lg:px-6 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          {/* Brand */}
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 rounded-md bg-primary flex items-center justify-center">
              <Icon icon={Command} size="xs" color="white" />
            </div>
            <p className="text-sm text-muted-foreground">
              <span className="font-semibold text-foreground">ShadeX</span> Admin Panel
            </p>
            <Separator orientation="vertical" className="h-4 hidden sm:block" />
            <p className="hidden sm:flex items-center gap-1 text-xs text-muted-foreground">
              Made with <Icon icon={Heart} size="xs" color="danger" className="fill-danger" /> — v1.0.0
            </p>
          </div>

          {/* Copyright */}
          <p className="text-xs text-muted-foreground order-last sm:order-none">
            © {year} ShadeX Inc. All rights reserved.
          </p>

          {/* Links */}
          <div className="flex items-center gap-4">
            {['Privacy', 'Terms', 'Contact', 'Docs'].map((link) => (
              <Link
                key={link}
                to="#"
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                {link}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;